const basePath = process.env.REACT_APP_API_PATH

export const APIPath = {
    server: basePath,
    // auth
    auth: 'auth/login',
    login: `${basePath}users/validate`,
    register: 'RegisterUser',
    setPassword: 'user/UpdatePassword',
    updatePassword: 'Users/UpdatePassword',
    validateToken: `${basePath}users/ValidateToken`,
    forgotPassword: 'ForgotPassword',
    socialLogin: 'Users/ValidateProviderToken',
    checkUserExists: 'checkUserExists',

    // Action Plan APIs
    actionPlan: `${basePath}user/ActionPlan`,
    actionPlanAssignTickets: `${basePath}user/ActionPlan/AssignTickets/`,
    actionPlanResponse: `${basePath}user/ActionPlanResponse`,
    actionPlanResponseCreate: `${basePath}user/ActionPlanResponse/Create`,
    actionPlanResponseUpdate: `${basePath}user/ActionPlanResponse/Update`,
    actionPlanMediaUpdate: `${basePath}Inspection/Medias/Update`,
    actionPlanGetSignature: `${basePath}user/ActionPlan/GetByUId/`,
    actionPlanUpdateSignature: `${basePath}user/ActionPlan/UpdateSignature`,

    // Customer User APIs
    customerUser: `${basePath}user/customerUser`,
    customerUserById: `${basePath}user/customerUser/`,
    customerUserByUserId: `${basePath}user/customerUser/userId/`,
    customerUserByCompany: `${basePath}user/customerUser/company/`,
    customerUserUpdate: `${basePath}user/customerUser/Update`,
    customerUserDelete: `${basePath}user/customerUser/Delete/`,
    customerUserList: `${basePath}user/customerUser/List`,
    customerUserSync: `${basePath}user/customerUser/Sync`,
    // department role model: own (head of department) / audit per assigned department
    departmentRelation: `${basePath}user/RoleModel/DepartmentRelation`,

    // Template User APIs
    templateUser: `${basePath}user/templateUser`,
    templateUserById: `${basePath}user/templateUser/`,
    templateUserByUserId: `${basePath}user/templateUser/byUser/`,
    templateUserByTemplate: `${basePath}user/templateUser/byTemplate/`,
    templateUserUpdate: `${basePath}user/templateUser/update`,
    templateUserDelete: `${basePath}user/templateUser/Delete/`,
    templateUserList: `${basePath}user/templateUser/List`,
    templateUserSync: `${basePath}user/templateUser/Sync`,

    // Master table
    multipleResponses: `${basePath}user/TemplateResponseType`,
    multipleTempleteList: `${basePath}user/MyTemplates`,
    publicTempleteList: `${basePath}user/PublicTemplate`,
    publictempleteDetails: `${basePath}user/Template?TemplateId=`,
    templeteDetails: `${basePath}user/Template?TemplateId=`,
    sortBy: `${basePath}SortBy`,
    templeteType: `${basePath}TemplateType`,
    publictempleteType: `${basePath}TemplateType`,
    masterResponse: `${basePath}user/TemplateResponseType`,
    template: 'user/Template',
    templateUpdate: 'user/Template/Update',
    formulaCheck: 'user/Template/Formula/Check',
    templateSection: 'user/Template/Section',
    librarypublictemplete: `${basePath}CopyInspectionFromTemplate?TemplateId=`,
    multiResponses: 'user/MultiResponses',
    getMultiResponsesByTemplateAndGroup: `${basePath}user/MultiResponses/`,
    updateMultipleResponse: `${basePath}user/MultiResponses/Update`,
    removeTemplate: `${basePath}userTemplate/`,
    templateOrder: `${basePath}Template/Orders`,
    cloneTemplate: `${basePath}user/Template/Clone`,
    // web user
    webuser: `${basePath}Users`,
    adminCreateUser: `${basePath}Users/AdminCreate`,
    role: `${basePath}UserRole`,
    roleType: `${basePath}user/GetRoleType`,
    permissions: `${basePath}user/permission`,

    // custom report
    customeReport: `${basePath}Template/CustomReport`,
    customReport: `${basePath}Template/ReportSection`,
    customComponentReport: `${basePath}Template/ReportComponent`,
    cumulativeReport: `${basePath}user/CustomReport`,
    getCustomReportTypes: `${basePath}user/GetCustomReportType`,

    // Participants
    participation: `${basePath}User/Participation`,

    // Logging
    logging: `${basePath}ErrorLogging`,

    // report
    report: `${basePath}CustomDashboard`,
    customDashboardType1: `${basePath}CustomDashboard/Type/1`,
    combineTemplateReport: `${basePath}CombineTemplateReport`,
    shareReport: `${basePath}Report/Share`,
    shareReportByEmails: `${basePath}Report/Email`,
    emailRecipients: `${basePath}User/EmailRecipients`,
    sendMultiReport: `${basePath}Report/SendMultiReport`,
    checkInReport: `${basePath}User/CheckInReport`,
    auditorSummary: `${basePath}Report/AuditorSummary`,
    processHealthOptions: `${basePath}Report/ProcessHealth/Options`,
    processHealth: `${basePath}Report/ProcessHealth`,

    // users
    users: `${basePath}UserDetails`,

    // status
    status: `${basePath}TemplateStatus`,

    // CompanyTemplate
    companyTemplate: `${basePath}CompanyTemplate`,

    // customer
    customer: `${basePath}Eauditor/Customer`,
    externalCustomer: `${basePath}User`,
    updateCustomer: `${basePath}Eauditor/CustomerUpdate`,
    customerAdditionalInfo: `${basePath}Eauditor/Customer/AdditionalInfo/`,
    customClients: `${basePath}user/CustomClients`,

    // group
    teamGroup: `${basePath}TeamGroup`,
    teamGroupUpdate: `${basePath}TeamGroup/Update`,

    teamGroupMember: `${basePath}TeamGroupMember`,
    teamGroupMemberUpdate: `${basePath}TeamGroupMember/Update`,

    teamMember: `${basePath}TeamMember`,
    teamMemberByAudit: `${basePath}TeamMember?callingSource=1&auditId=`,
    teamMemberByAuditResponse: `${basePath}TeamMember?callingSource=2&auditId=`,

    teamGroupCapa: `${basePath}EAuditor/TeamGroupCapa`,
    teamGroupCapaRemove: `${basePath}EAuditor/TeamGroupCapa/Remove`,
    teamGroupCapaUpdate: `${basePath}EAuditor/TeamGroupCapa`,
    // inspection
    inspection: `${basePath}Inspection`,
    auditEmails: auditId =>
        `${basePath}Inspection/${encodeURIComponent(auditId)}/Emails`,
    copyInspection: `${basePath}CopyInspectionFromTemplate`,
    getAudit: `${basePath}Inspection?AuditId=`,
    addNote: `${basePath}Inspection/Note`,
    inspectionReport: `${basePath}InspectionReport?AuditId=`,
    inspectionReportWithTickets: `${basePath}Audit/InspectionReportWithTickets`,
    inspectionReview: `${basePath}Inspection/Preview`,
    inspectionReportCumulative: `${basePath}InspectionReport/Cumulative`,
    inspectionCustomReport: `${basePath}CustomReport?AuditId=`,
    questionComment: `${basePath}QuestionComment`,
    sectionComment: `${basePath}SectionComment`,
    taskRejection: `${basePath}TaskRejection`,
    scheduleTask: `${basePath}ScheduleTask`,
    addScheduleTask: `${basePath}ScheduleTask`,
    updateScheduleTask: `${basePath}ScheduleTask`,
    removeScheduleTask: `${basePath}ScheduleTask`,
    scheduleByWeek: `${basePath}Task/ScheduleByWeek`,
    scheduleByWeekEnabled: `${basePath}Company/ScheduleByWeekEnabled`,

    // upload-inspection-media
    uploadSignedUrl: `${basePath}Inspection/UploadSignedURL`,

    // task-inspection
    inspectionTask: `${basePath}InspectionTask`,
    inspectionTaskUpdate: `${basePath}InspectionTaskUpdate`,
    dashboardStats: `${basePath}Dashboard/Stats`,
    dashboardTasks: `${basePath}Dashboard/Tasks`,
    dashboardTaskFullPreview: `${basePath}Dashboard/Tasks/`,
    // home dashboard (GET Dashboard/Home + Settings / finding answers)
    homeDashboard: `${basePath}Dashboard/Home`,
    superAdminOverview: `${basePath}user/SuperAdmin/Overview`,
    superAdminCompanies: `${basePath}user/SuperAdmin/Companies`,
    superAdminSignIns: `${basePath}user/SuperAdmin/SignIns`,
    superAdminWatchlist: `${basePath}user/SuperAdmin/Watchlist`,
    userPhone: `${basePath}user/Phone`,
    homeDashboardSetting: `${basePath}user/Dashboard/Setting`,
    homeDashboardFindingAnswers: `${basePath}user/Dashboard/FindingAnswers`,
    mediaUpload: `${basePath}Inspection/Media/Upload`,
    saveUpload: `${basePath}inspection/Medias`,
    deleteMedia: `${basePath}Inspection/Media/Delete`,

    // templateMedia
    templateMedia: `${basePath}Template/Media?mediaType=1`,
    multiResponceType: `${basePath}Template/MultiResponseType`,

    // Invite Token
    sendInvitation: 'user/SendInviteToken',
    validateInvitation: 'user/InviteToken',

    copySection: `${basePath}CopySectionFromTemplate`,
    removeSection: `${basePath}Inspection/DeleteSection`,
    /** Upsert section N/A state: { AuditId, SectionId, IsNASelected } */
    sectionNAState: `${basePath}Inspection/Section/NAState`,

    // Company
    customerCompanySetting: `${basePath}CustomerCompanySetting`,
    updatecustomerCompanySetting: `${basePath}CustomerCompanySetting/Update`,
    auditCompanies: `${basePath}Companies`,

    // meta-data
    allTimeZones: `${basePath}AllTimeZones`,
    /** Curated 26-entry catalog (Report Settings / consolidated report send time). */
    timezones: `${basePath}Timezones`,

    // template
    templateStatus: `${basePath}Template/Status`,
    templateSetting: `${basePath}TemplateSetting`,
    templateSettingSave: `${basePath}TemplateSetting/Save`,
    templatePastInspections: templateId =>
        `${basePath}Template/${templateId}/PastInspections`,

    // report settings
    reportSettings: `${basePath}Company/ReportSetting`,
    reportSettingsList: `${basePath}Template/ReportSubSection`,

    // company Theme
    companyTheme: `${basePath}Company/GetColorTheme`,
    insertColorTheme: `${basePath}Company/InsertColorTheme`,
    updateColorTheme: `${basePath}Company/UpdateColorTheme`,

    // company name formats
    inspectionNameConfig: companyId =>
        `${basePath}Company/${companyId}/InspectionNameConfig`,
    pdfFilenameConfig: companyId =>
        `${basePath}Company/${companyId}/PdfFilenameConfig`,

    // PDF Image Compression Settings (per-company)
    pdfImageCompressionSettings: companyId =>
        `${basePath}Company/${companyId}/PdfImageCompressionSettings`,
    pdfImageCompressionSettingsReset: companyId =>
        `${basePath}Company/${companyId}/PdfImageCompressionSettings/Reset`,
    pdfImageCompressionSettingsPreview: companyId =>
        `${basePath}Company/${companyId}/PdfImageCompressionSettings/Preview`,

    // Share Report Email Subject Format (per-company)
    shareEmailSubjectFormat: `${basePath}CompanySetting/ShareEmailSubjectFormat`,
    shareEmailSubjectFormatPreview: `${basePath}CompanySetting/ShareEmailSubjectFormat/Preview`,

    // Photo GPS caption under PDF media (AND: company + user both true; NULL => true)
    companyShowPhotoGps: `${basePath}CompanySetting/ShowPhotoGps`,
    userShowPhotoGps: `${basePath}UserSetting/ShowPhotoGps`,

    // comments
    comments: `${basePath}Template/Comments`,
    removeComments: `${basePath}Template/Comments/Remove`,

    // capa
    publicInspection: `${basePath}User/PublicInspection`,

    // Public Inspection APIs
    publicInspectionTask: `${basePath}User/PublicInspection/Task`,
    publicInspectionComplete: `${basePath}User/PublicInspection/Task/Complete`,
    publicInspectionSubmit: `${basePath}User/PublicInspection/Task`,

    // email
    sendEmail: `${basePath}PublicTemplate/Email/Create`,
    sendEmailWithPDF: `${basePath}PublicTemplate/EmailTemplate`,
    updateEmail: `${basePath}PublicTemplate/Email/Update`,
    deleteEmail: `${basePath}PublicTemplate/Email/SoftDelete/`,
    getEmailsByTemplateId: `${basePath}PublicTemplate/Email/GetByTemplateId/`,
    getEmailById: `${basePath}PublicTemplate/Email/GetById/`,
    emailDueTemplateReminder: `${basePath}EmailduetemplateReminder`,

    // AI Template APIs
    aiTemplateLanguage: `${basePath}Eauditor/AITemplate/Language`,
    aiTemplateIndustry: `${basePath}Eauditor/AITemplate/Industry/WithSubcategories`,
    aiTemplateGenerate: `${basePath}Eauditor/AITemplate/Generate`,
    aiTemplateImport: `${basePath}Eauditor/AITemplate/import`,

    // Translation API
    translate: `${basePath}Eauditor/Translate`,

    // AI Audit Report (client backend)
    aiAuditGenerateReport: `${basePath}Eauditor/AIAudit/GenerateReport`,

    // Add this if you need the new endpoint to get templates for a group
    teamGroupTemplates: `${basePath}TeamGroup/templates/`,

    // Action Plan endpoints
    actionPlanAssignedTickets: `${basePath}user/ActionPlan/AssignTickets`,
    actionPlanMyTickets: `${basePath}user/ActionPlan/MyTicket`,
    actionPlanTicketStatus: `${basePath}user/ActionPlan/TicketStatus`,

    // Auto-Ticket Rules (Action Plan Rules) — paths per Postman collection (no Audit/ prefix)
    actionPlanLookup: `${basePath}ActionPlanLookup`,
    actionPlanRule: `${basePath}ActionPlanRule`,
    actionPlanRuleCount: templateId =>
        `${basePath}ActionPlanRule/Template/${templateId}/Count`,
    templateActionPlanRules: templateId =>
        `${basePath}Template/${templateId}/ActionPlanRules`,
    templateActionPlanRulesBulkSave: templateId =>
        `${basePath}Template/${templateId}/ActionPlanRules/BulkSave`,
    templateActionPlanTickets: templateId =>
        `${basePath}Template/${templateId}/Tickets`,
    actionPlanTeams: `${basePath}ActionPlan/Teams`,
    actionPlanVendorCompanies: `${basePath}ActionPlan/VendorCompanies`,
    actionPlanVendorCompany: `${basePath}ActionPlan/VendorCompany`,
    actionPlanVendorCompanyById: vendorCompanyId =>
        `${basePath}ActionPlan/VendorCompany/${vendorCompanyId}`,
    actionPlanVendorContacts: vendorCompanyId =>
        `${basePath}ActionPlan/VendorContacts?vendorCompanyId=${vendorCompanyId}`,
    actionPlanVendorContact: `${basePath}ActionPlan/VendorContact`,
    actionPlanVendorContactById: vendorContactId =>
        `${basePath}ActionPlan/VendorContact/${vendorContactId}`,

    // Escalation Policy (rev 25) — Postman: EAuditor · Auto-Ticket Escalation V1
    actionPlanEscalationPolicy: `${basePath}ActionPlan/EscalationPolicy`,
    actionPlanEscalationPolicyById: policyId =>
        `${basePath}ActionPlan/EscalationPolicy/${policyId}`,
    actionPlanRuleEscalationPolicy: (ruleId, policyId) =>
        `${basePath}ActionPlan/Rule/${ruleId}/EscalationPolicy/${policyId}`,
    actionPlanRuleEscalationPolicyUnlink: ruleId =>
        `${basePath}ActionPlan/Rule/${ruleId}/EscalationPolicy`,
    actionPlanTicketWatcher: ticketId =>
        `${basePath}ActionPlan/Ticket/${ticketId}/Watcher`,
    actionPlanTicketWatcherById: (ticketId, watcherId) =>
        `${basePath}ActionPlan/Ticket/${ticketId}/Watcher/${watcherId}`,

    // ActionPlan Category CRUD — Postman: EAuditor · ActionPlan Category CRUD (2026-09-14)
    // Admin list/create/update/delete. Rule-editor dropdown still uses ActionPlanLookup/Categories.
    actionPlanCategory: `${basePath}ActionPlanCategory`,
    actionPlanCategoryById: categoryId =>
        `${basePath}ActionPlanCategory/${categoryId}`,

    // Auto-Ticket detail page (new framework — E_Audit_ActionPlan_Ticket)
    autoTicketGet: ticketId => `${basePath}user/AutoTicket/Get/${ticketId}`,
    autoTicketByAudit: auditId =>
        `${basePath}user/AutoTicket/ByAudit/${auditId}`,
    autoTicketComment: ticketId =>
        `${basePath}user/AutoTicket/${ticketId}/Comment`,
    autoTicketAcknowledge: ticketId =>
        `${basePath}user/AutoTicket/${ticketId}/Acknowledge`,
    autoTicketResolve: ticketId =>
        `${basePath}user/AutoTicket/${ticketId}/Resolve`,
    autoTicketClose: ticketId =>
        `${basePath}user/AutoTicket/${ticketId}/Close`,
    autoTicketReassign: ticketId =>
        `${basePath}user/AutoTicket/${ticketId}/Reassign`,
    autoTicketAssignableUsers: `${basePath}user/AutoTicket/AssignableUsers`,
    autoTicketCompanySetting: `${basePath}user/AutoTicket/CompanySetting`,
    // Voice inspection mode (mobile); company settings + translation review are admin-only.
    voiceLanguages: `${basePath}Mobile/Voice/Languages`,
    voiceCompanySetting: `${basePath}user/Voice/CompanySetting`,
    voiceTranslations: `${basePath}user/Voice/Translations`,
    voiceTranslation: translationId =>
        `${basePath}user/Voice/Translation/${translationId}`,
    voiceAccuracyReport: `${basePath}user/Voice/AccuracyReport`,
    autoTicketCancel: ticketId =>
        `${basePath}user/AutoTicket/${ticketId}/Cancel`,
    autoTicketRelease: auditId =>
        `${basePath}user/AutoTicket/Audit/${auditId}/Release`,
    actionPlanTicketReopen: ticketId =>
        `${basePath}ActionPlanTicket/${ticketId}/Reopen`,
    tickets: `${basePath}Tickets`,
    autoTicketMagicGet: token => `${basePath}public/Tickets/Magic/${token}`,
    autoTicketMagicComment: token =>
        `${basePath}public/Tickets/Magic/${token}/Comment`,
    autoTicketDigestGet: token => `${basePath}public/Tickets/Digest/${token}`,

    customerGroup: `${basePath}user/CustomerGroup`,
    customerGroupUpdate: `${basePath}user/CustomerGroup/update`,

    // Customer Notification APIs
    customerNotification: `${basePath}User/Customer/Notification`,
    customerNotificationByCustomerId: `${basePath}User/Customer/Notification/`,
    customerNotificationDelete: `${basePath}User/Customer/Notification/Delete`,

    // Template Group APIs
    templateGroup: `${basePath}Template/Group`,
    templateGroupUpdate: `${basePath}Template/Group/update`,
    templateGroupById: `${basePath}Template/Group/GetByGroupId?groupId=`,

    // Template Combine APIs (Sequence Group, Sequence Detail, Mapping)
    sequenceGroupGetByCompany: `${basePath}User/Template/Combine/Groups`,
    sequenceGroupGetById: `${basePath}User/Template/Combine/Group`,
    sequenceGroupSave: `${basePath}User/Template/Combine/Group`,
    sequenceGroupDelete: `${basePath}User/Template/Combine/Group/Delete`,
    sequenceDetailGetByGroupId: `${basePath}User/Template/Combine/GroupDetails`,
    sequenceDetailGetByTemplate: `${basePath}User/Template/Combine/Details/ByTemplate`,
    sequenceDetailSave: `${basePath}User/Template/Combine/Detail`,
    sequenceDetailDelete: `${basePath}User/Template/Combine/Detail/Delete`,
    mappingGetByTarget: `${basePath}User/Template/Combine/Mappings/Target`,
    mappingGetBySource: `${basePath}User/Template/Combine/Mappings/Source`,
    mappingGetById: `${basePath}User/Template/Combine/Mapping`,
    mappingSave: `${basePath}User/Template/Combine/Mapping`,
    mappingDelete: `${basePath}User/Template/Combine/Mapping/Delete`,
    previousTemplate: `${basePath}User/Template/Combine/PreviousTemplate`,

    // Asset Manager APIs
    assetManagerCategoryList: `${basePath}User/AssetManager/Category/List`,
    assetManagerCategoryGet: `${basePath}User/AssetManager/Category/Get`,
    assetManagerCategorySave: `${basePath}User/AssetManager/Category/Save`,
    assetManagerCategoryDelete: `${basePath}User/AssetManager/Category/Delete`,
    assetManagerLocationList: `${basePath}User/AssetManager/Location/List`,
    assetManagerLocationGet: `${basePath}User/AssetManager/Location/Get`,
    assetManagerLocationSave: `${basePath}User/AssetManager/Location/Save`,
    assetManagerLocationDelete: `${basePath}User/AssetManager/Location/Delete`,
    assetManagerAssetList: `${basePath}User/AssetManager/Asset/List`,
    assetManagerAssetGet: `${basePath}User/AssetManager/Asset/Get`,
    assetManagerAssetSave: `${basePath}User/AssetManager/Asset/Save`,
    assetManagerAssetDelete: `${basePath}User/AssetManager/Asset/Delete`,
    assetManagerInspectionListByAsset: `${basePath}User/AssetManager/Inspection/ListByAsset`,
    assetManagerInspectionGet: `${basePath}User/AssetManager/Inspection/Get`,
    assetManagerInspectionSave: `${basePath}User/AssetManager/Inspection/Save`,
    assetManagerInspectionDelete: `${basePath}User/AssetManager/Inspection/Delete`,
    assetManagerInspectionItemList: `${basePath}User/AssetManager/InspectionItem/List`,
    assetManagerInspectionItemSave: `${basePath}User/AssetManager/InspectionItem/Save`,
    assetManagerInspectionItemDeleteByInspection: `${basePath}User/AssetManager/InspectionItem/DeleteByInspection`,
    assetManagerInspectionMediaList: `${basePath}User/AssetManager/InspectionMedia/List`,
    assetManagerInspectionMediaSave: `${basePath}User/AssetManager/InspectionMedia/Save`,
    assetManagerInspectionMediaDelete: `${basePath}User/AssetManager/InspectionMedia/Delete`,

    /**
     * Asset ↔ inspection links (EAMM-003 / EAUDITOR-485–488).
     * Paths are provisional: update to match backend contract when delivered.
     */
    assetManagerAssetAuditLinkSave: `${basePath}User/AssetManager/Asset/AuditLink/Save`,
    assetManagerAssetInspectionHistory: `${basePath}User/AssetManager/Asset/InspectionHistory`,
    assetManagerAuditListByAsset: `${basePath}User/AssetManager/Audit/ListByAsset`,

    // Asset maintenance (EAMM-005 / EAUDITOR-407): maintenance tasks
    maintenanceRoot: `${basePath}Maintenance/`,
    maintenanceTypes: `${basePath}Maintenance/Types`,
    maintenanceTask: `${basePath}Maintenance/Task`,
    maintenanceAsset: `${basePath}Maintenance/Asset/`,
    maintenanceAudit: `${basePath}Maintenance/Audit/`,
    maintenanceSchedule: `${basePath}Maintenance/Schedule`,
    maintenanceOccurrence: `${basePath}Maintenance/Occurrence/`,

    // Question comments (review threads per question, 2026-10-30)
    questionThreadsRoot: `${basePath}`,
    questionThreadsWaitingOnMe: `${basePath}Threads/WaitingOnMe`,
    templateReviewSettings: templateId =>
        `${basePath}user/Template/${templateId}/ReviewSettings`,

    userUpdate: `${basePath}user/Update`,

    // Contact Us
    contactUs: `${basePath}ContactUs`,

    // Support Ticket APIs
    supportTicketCreate: `${basePath}User/SupportTicket/Create`,
    supportTicketGetById: `${basePath}User/SupportTicket/ById`,
    supportTicketGetByEmail: `${basePath}User/SupportTicket/ByEmail`,
    supportTicketGetByStatus: `${basePath}User/SupportTicket/ByStatus`,
    supportTicketIssueTypes: `${basePath}User/SupportTicket/IssueTypes`,
    supportTicketUpdateStatus: `${basePath}User/SupportTicket/UpdateStatus`,
    supportTicketDelete: `${basePath}User/SupportTicket/Delete`,
    supportTicketAttachments: `${basePath}User/SupportTicket/Attachments`,

    // Invoice APIs
    invoiceCreate: `${basePath}company/Invoice/CreateWithAudits`,
    getCompletedAudits: `${basePath}Company/Invoice/CompletedAudits`,
    // Company Invoice Settings
    companyInvoiceSettingGet: `${basePath}Company/Invoice/Setting/Get`,
    companyInvoiceSettingSave: `${basePath}Company/Invoice/Setting/Save`,
    // Invoice Number Format Settings API
    companyInvoiceNumberFormat: `${basePath}company/Invoice/Settings/NumberFormat`,
    companyInvoiceNumberFormatPreview: `${basePath}company/Invoice/Settings/NumberFormat/Preview`,
    // Invoice Search
    invoiceSearch: `${basePath}company/Invoice/Search`,
    // Invoice Detail + Update + Delete
    invoiceGetById: `${basePath}company/Invoice/`,
    invoiceUpdateHeader: `${basePath}company/Invoice/Update`,
    invoiceUpdateLines: `${basePath}company/Invoice/`,
    invoiceSoftDelete: `${basePath}company/Invoice/`,

    // Invoice Rule APIs
    invoiceRuleSave: `${basePath}Company/Invoice/Rule/Save`,
    invoiceRuleList: `${basePath}Company/Invoice/Rule/List`,
    invoiceRuleGet: `${basePath}Company/Invoice/Rule/Get`,
    invoiceRuleDelete: `${basePath}Company/Invoice/Rule/Delete`,

    // Announcement APIs
    announcement: `${basePath}Announcement`,
    announcementUnreadCount: `${basePath}Announcement/Unread/Count`,
    announcementDeactivate: id => `${basePath}Announcement/${id}/Deactivate`,
    announcementRead: id => `${basePath}Announcement/${id}/Read`,

    // Master Answer Lists
    masterAnswerList: `${basePath}Master/AnswerList`,
    masterAnswerListByCompany: companyId =>
        `${basePath}Master/AnswerList/Company/${companyId}`,
    masterAnswerListById: listId => `${basePath}Master/AnswerList/${listId}`,
    masterAnswerListItems: listId =>
        `${basePath}Master/AnswerList/${listId}/Items`,
    masterAnswerListItemsBulk: listId =>
        `${basePath}Master/AnswerList/${listId}/Items/Bulk`,
    masterAnswerListItem: (listId, itemId) =>
        `${basePath}Master/AnswerList/${listId}/Items/${itemId}`,

    // Master Answers — Migration Wizard (Super Admin)
    masterMigrationOptionSets: companyId =>
        `${basePath}Master/Migration/Tenant/${companyId}/OptionSets`,
    masterMigrationPreview: `${basePath}Master/Migration/Preview`,
    masterMigrationCommit: `${basePath}Master/Migration/Commit`,
    masterMigrationRollback: masterListId =>
        `${basePath}Master/Migration/Rollback/${masterListId}`,
    masterMigrationHistory: companyId =>
        `${basePath}Master/Migration/Tenant/${companyId}/History`,

    templateQuestionAssignMasterList: (questionId, masterListId) =>
        `${basePath}user/Template/Question/${questionId}/MasterList/${masterListId}`,
    templateQuestionUnassignMasterList: questionId =>
        `${basePath}user/Template/Question/${questionId}/MasterList`,

    // Section workflow (Customer Service Claim Portal)
    auditSectionStatus: (auditId, templateUniqueId) =>
        `${basePath}Audit/${auditId}/SectionStatus?templateUniqueId=${templateUniqueId}`,
    // notes is a query param only — no request body (Postman #9).
    auditSectionComplete: (auditId, sectionId, templateUniqueId, notes = '') => {
        const params = new URLSearchParams({
            templateUniqueId: String(templateUniqueId),
            notes: String(notes ?? ''),
        })
        return `${basePath}Audit/${auditId}/Section/${encodeURIComponent(
            sectionId,
        )}/Complete?${params.toString()}`
    },
    auditSectionUncomplete: (auditId, sectionId, templateUniqueId) =>
        `${basePath}Audit/${auditId}/Section/${encodeURIComponent(
            sectionId,
        )}/Uncomplete?templateUniqueId=${templateUniqueId}`,
    auditSectionEdit: `${basePath}Audit/SectionEdit`,

    // All Claims list (Customer Service Claim Portal)
    claimList: `${basePath}Claim/List`,
    claimRemoveBulk: `${basePath}Claim/RemoveBulk`,
    customerExtensiveSearch: `${basePath}Customer/Extensive`,

    // Section workflow setup (Super Admin)
    templateSectionWorkflow: templateUniqueId =>
        `${basePath}Template/${templateUniqueId}/SectionWorkflow`,
    sectionNotificationRecipients: (templateUniqueId, sectionId) =>
        `${basePath}Template/${templateUniqueId}/Section/${encodeURIComponent(
            sectionId,
        )}/NotificationRecipients`,
    userSearch: `${basePath}User/Search`,

    // Menu Setting
    menuSetting: `${basePath}User/Menu/Items`,
    menuCreate: `${basePath}User/Menu/MenuItem/Create`,
    menuUpdate: `${basePath}User/Menu/MenuItem`,
    menuDefaults: `${basePath}MenuDefaults`,
    menuDefaultsSave: `${basePath}MenuDefaults/Save`,

    // Permissions
    permissionsList: `${basePath}User/Menu/Permissions`,
    permissionsCreate: `${basePath}User/Menu/Permission/Create`,
    permissionsUpdate: `${basePath}User/Menu/Permission`,

    // Menu - Permission Mapping
    menuPermission: `${basePath}User/Menu/MenuItem`,
    menuPermissionAssignRemove: `${basePath}User/Menu/MenuItem`,

    // Company Menu Permission
    companyMenuPermissionsShow: companyId =>
        `${basePath}User/Menu/Company/${companyId}/Permissions`,
    companyMenuPermissionSave: (companyId, menuId) =>
        `${basePath}User/Menu/Company/${companyId}/Permission/${menuId}`,
    companyModuleToggle: (companyId, moduleKey) =>
        `${basePath}User/Menu/Company/${companyId}/Module/${moduleKey}`,

    // User Menu Permission
    userMenuPermissionsShow: userId =>
        `${basePath}User/Menu/${userId}/Permissions`,
    userMenuPermissionSave: (userId, menuId) =>
        `${basePath}User/Menu/${userId}/Permission/${menuId}`,
    userModuleToggle: (userId, moduleKey) =>
        `${basePath}User/Menu/${userId}/Module/${moduleKey}`,

    // Impersonation (Super Admin "Login as this user")
    impersonateStart: `${basePath}Users/ImpersonateStart`,
    impersonateEnd: `${basePath}Users/ImpersonateEnd`,
    impersonateForceEnd: sessionId =>
        `${basePath}Users/ImpersonateForceEnd/${sessionId}`,
    impersonationHistory: `${basePath}Users/ImpersonationHistory`,

    // Consolidated Report Email schedules
    consolidatedReportSchedule: `${basePath}ConsolidatedReportSchedule`,
    consolidatedReportScheduleById: id =>
        `${basePath}ConsolidatedReportSchedule/${id}`,
    consolidatedReportScheduleHold: id =>
        `${basePath}ConsolidatedReportSchedule/${id}/Hold`,
    consolidatedReportScheduleTestSend: id =>
        `${basePath}ConsolidatedReportSchedule/${id}/TestSend`,
    consolidatedReportScheduleFireNow: id =>
        `${basePath}ConsolidatedReportSchedule/${id}/FireNow`,
    consolidatedReportScheduleRuns: `${basePath}ConsolidatedReportSchedule/Runs`,
    consolidatedReportScheduleRunHistory: id =>
        `${basePath}ConsolidatedReportSchedule/${id}/RunHistory`,
    consolidatedReportScheduleColumnsSave: `${basePath}User/ConsolidatedReportSchedule/columns/save`,
    consolidatedReportScheduleColumns: id =>
        `${basePath}ConsolidatedReportSchedule/${id}/columns`,
    consolidatedReportTemplateUsage: days =>
        `${basePath}ConsolidatedReportSchedule/TemplateUsage?days=${days}`,

    // Report Approval
    approvalPendingReports: `${basePath}Approval/PendingReports`,
    approvalReportDetail: completedReportId =>
        `${basePath}Approval/Report/${completedReportId}`,
    approvalReportApprove: completedReportId =>
        `${basePath}Approval/Report/${completedReportId}/Approve`,
    approvalCanApprove: `${basePath}Approval/CanApprove`,
    approvalWorkflow: templateId =>
        `${basePath}Template/${templateId}/ApprovalWorkflow`,
    approvalReportAdvance: completedReportId =>
        `${basePath}Approval/Report/${completedReportId}/Advance`,
    approvalReportReject: completedReportId =>
        `${basePath}Approval/Report/${completedReportId}/Reject`,
    approvalReportHistory: completedReportId =>
        `${basePath}Approval/Report/${completedReportId}/History`,
    // e-mailed no-login approval link (public, the token is the only credential)
    approvalSignDetail: token =>
        `${basePath}public/Approval/Sign/${encodeURIComponent(token)}`,
    approvalSignHistory: token =>
        `${basePath}public/Approval/Sign/${encodeURIComponent(token)}/History`,
    approvalSignAdvance: token =>
        `${basePath}public/Approval/Sign/${encodeURIComponent(token)}/Advance`,
    approvalSignReject: token =>
        `${basePath}public/Approval/Sign/${encodeURIComponent(token)}/Reject`,
    approvalReportResendLink: completedReportId =>
        `${basePath}Approval/Report/${completedReportId}/ResendLink`,

    // Mobile QR Code Generator
    mobileQrCode: `${basePath}Mobile/QrCode`,

    // Subscription / Free-plan usage (EAUDITOR-692)
    subscriptionUsage: `${basePath}Subscription/Usage`,

    // Service Plan / Stripe billing (ServicePlan-Flow mockup)
    paymentStatus: `${basePath}User/PaymentStatus`,
    publicKey: `${basePath}PublicKey`,
    paymentFormat: `${basePath}Payment/Format`,
    servicePlan: `${basePath}ServicePlan`,
    purchaseOrder: `${basePath}User/PurchaseOrder`,
    paymentConfirm: `${basePath}User/PaymentConfirm`,
    payNow: `${basePath}User/PayNow`,
    deactivateUser: uniqueId => `${basePath}User/${uniqueId}/DeactiveUser`,
    removeInvitedTeamMember: uniqueId =>
        `${basePath}User/${uniqueId}/RemoveInvitedTeamMember`,
    cartPricing: `${basePath}Cart/Pricing`,
    cartQuote: `${basePath}Cart/Quote`,
    cartCheckout: `${basePath}Cart/Checkout`,
    cartConfirm: `${basePath}Cart/Confirm`,
    cartOrder: cartOrderId => `${basePath}Cart/Order/${cartOrderId}`,
    cancelPlan: `${basePath}User/CancelPlan`,
    retentionOffer: `${basePath}User/Offer`,
    offerAccepted: `${basePath}User/OfferAccepted`,
    paymentHistory: `${basePath}User/PaymentHistory`,

    reasonPreset: `${basePath}User/ReasonPreset`,
    reasonPresetGenerate: `${basePath}User/ReasonPreset/Generate`,
    reasonPresetSave: `${basePath}User/ReasonPreset/Save`,
    reasonPresetSetting: `${basePath}User/ReasonPreset/Setting`,
    reasonPresetSettingSave: `${basePath}User/ReasonPreset/Setting/Save`,
    reasonPresetSelectionSave: `${basePath}User/ReasonPreset/Selection/Save`,
}
